import TemplateView from "../../TemplateView";
import {HIERARCHY_LEVEL_CLASSES} from "./constants";

export default class Counter extends TemplateView {
    constructor({
        hierarchyLevel = "",
    }) {
        super();
        this.props = {
            hierarchyLevel,
        }
        this.state = {
            value: 0,
            pale: false,
        };
        this.onStateChanged(() => this._updateCounter());
    }

    _updateCounter() {
        this.$el.toggleClass("counterWithZeroElements",this.state.value === 0);
        this.$el.toggleClass("nonZeroCounter", this.state.value !== 0);
        this.$counterText.text(this.state.value);
        this.$el.toggleClass("paleCounter", this.state.pale);
    }

    templateHtml() {
        return "<div class='components_cptCounter <%-hierarchyLevelClass%>'>" +
               "    <div class='counterText'></div>" +
               "</div>";
    }

    templateModel() {
        return {
            hierarchyLevelClass: HIERARCHY_LEVEL_CLASSES[this.props.hierarchyLevel],
        }
    }

    afterRender() {
        this.$counterText = this.find('.counterText');
    }
}



// WEBPACK FOOTER //
// ./web/js/components/counterCPT/Counter.js